<div class="flex flex-col gap-2">
  <div class="flex flex-row justify-between items-center">
    <div class="flex flex-row gap-2 items-center">
      <button
        mat-stroked-button
        color="primary"
        [disabled]="isCurrentWeek()"
        (click)="navigateToCurrentWeek()"
      >
        Today
      </button>
      <button
        mat-icon-button
        aria-label="Previous week"
        [disabled]="isCurrentWeek()"
        (click)="navigateBack()"
      >
        <mat-icon>chevron_left</mat-icon>
      </button>
      <button
        mat-icon-button
        aria-label="Next week"
        (click)="navigateForward()"
      >
        <mat-icon>chevron_right</mat-icon>
      </button>
      <h2>{{ selectedDateRange() | dateRange }}</h2>
    </div>
    <mat-slide-toggle (change)="toggleWeekends($event)"
      >Show weekends</mat-slide-toggle
    >
  </div>
  <ng-content />
</div>
